import React from "react";
import { Link } from "react-router-dom";
import { SERVICES } from "../lib/brand";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-white py-16 sm:py-24 md:py-32"
    >
      {/* soft warm accent */}
      <div className="absolute top-24 right-0 w-[520px] h-[520px] rounded-full bg-[color:var(--dbe-red)]/5 blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 sm:gap-6 mb-10 sm:mb-14">
          <div>
            <p className="text-[color:var(--dbe-red)] text-xs tracking-[0.35em] uppercase font-bold">What we handle</p>
            <h2 className="mt-3 sm:mt-4 text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.02] font-bebas text-neutral-900">
              Complete pest &<br /><span className="text-[color:var(--dbe-red)]">termite solutions</span>
            </h2>
          </div>
          <p className="max-w-md text-neutral-600 text-base sm:text-lg">
            From termites to rodents to marine vessels - if it bugs you, we handle it.
            Every plan is tailored to your property, season, and pest pressure.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {SERVICES.map((s, i) => (
            <Link
              key={s.slug}
              to={`/services/${s.slug}`}
              data-testid={`service-card-${s.slug}`}
              className="group relative overflow-hidden rounded-2xl bg-white border border-neutral-200 hover:border-[color:var(--dbe-red)]/60 hover:-translate-y-1 transition-all duration-300 shadow-[0_20px_50px_-30px_rgba(15,15,25,0.15)] hover:shadow-[0_30px_60px_-25px_rgba(227,30,36,0.35)]"
              style={{ animationDelay: `${i * 60}ms` }}
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-neutral-100">
                <img
                  src={s.img}
                  alt={s.title}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute top-4 left-4 bg-[color:var(--dbe-red)] text-white text-[10px] uppercase tracking-wider font-bold px-3 py-1 rounded-full shadow">
                  {s.tag}
                </div>
                <div className="absolute bottom-4 right-4 w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center group-hover:bg-[color:var(--dbe-red)] transition-colors">
                  <i className={`fa-solid ${s.icon} text-[color:var(--dbe-red)] group-hover:text-white text-lg transition-colors`} />
                </div>
              </div>
              <div className="p-6">
                <h3 className="font-bebas text-2xl leading-tight tracking-wide text-neutral-900">{s.title}</h3>
                <p className="mt-2 text-sm text-neutral-600 leading-relaxed">{s.blurb}</p>
                <div className="mt-5 inline-flex items-center gap-2 text-[color:var(--dbe-red)] text-sm font-bold uppercase tracking-wider">
                  Learn More <i className="fa-solid fa-arrow-right text-xs transition-transform group-hover:translate-x-1" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
